import React from "react";

// DropdownMenuText component renders a list of selectable text items
const DropdownMenuText = ({ menu, onSelect, styleData }) => {
  return (
    <ul className="dropdown__lists-text">
      {/* Container for the list of dropdown text items */}
      {menu.map(
        (
          item // Iterate through each item in the menu array
        ) => (
          <li
            key={item.id} // Unique key for each list item to help React identify changes
            className="dropdown__list" // Base class for each dropdown item
            style={{
              color: styleData.web_main_color, // Text color set to main color from styleData
              "--dropdown-hover-color": styleData.secondary_color, // CSS variable for hover color
            }}
            onClick={() => onSelect(item)} // Click handler to select the item and trigger onSelect callback
          >
            {item.text} {/* Text displayed for the dropdown item */}
          </li>
        )
      )}
    </ul>
  );
};

export default DropdownMenuText; // Export the DropdownMenuText component for use in other parts of the application
